import { useState } from 'react'
import { readOutputDownload } from '@agent-runtime/client'
import { apiFetch } from '../../auth/apiClient'

export function useAttachmentDownload() {
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  async function download(url: string, fallbackFilename = 'allegato') {
    if (busy) return
    setBusy(true)
    setError('')
    try {
      if (!url) throw new Error('unavailable')
      const response = await apiFetch(url)
      const { blob, filename } = await readOutputDownload(response, fallbackFilename)
      const objectUrl = URL.createObjectURL(blob)
      const anchor = document.createElement('a')
      anchor.href = objectUrl
      anchor.download = filename
      anchor.click()
      window.setTimeout(() => URL.revokeObjectURL(objectUrl), 30_000)
    } catch {
      setError('Download non riuscito. Riprova; se il problema continua, contatta il supporto.')
    } finally {
      setBusy(false)
    }
  }
  return { download, error, busy }
}
